export default {
  group_name_placeholder: 'Establecer nombre del canal',
  group_purpose_placeholder: 'Establecer finalidad del canal',
};
